import Flex from '@/elements/Flex'
import Text from '@/elements/Text'
import NotificationCard from './NotificationCard'
import type { NotificationResponse } from '@/api/types/Notification'
import { Fragment } from 'react/jsx-runtime'
import Loading from '@/elements/Loading'
import { markNotificationAsRead } from '@/api/notifications'

function NotificationsList({
  notifications,
  loading,
  refetch,
}: {
  notifications: NotificationResponse[],
  loading: boolean,
  refetch: () => void,
}) {

  return (
    <Flex wfull py={3} px={3} className='card'>
      {loading ? (
        <Flex wfull style={{ height: 200 }}>
          <Loading />
        </Flex>
      ) : notifications.length === 0 ? (
        <Flex hfull align='center' justify='center' py={8} px={4}>
          <Text color='black-light-40'>There are no notifications to display.</Text>
        </Flex>
      ) : (
        notifications.map((notification, index) => (
          <Fragment key={notification.id}>
            <NotificationCard
              notification={notification}
              markAsRead={() => {
                markNotificationAsRead(notification.id).then(() => refetch())
              }}
            />
            {index !== notifications.length - 1 && (
              <Flex
                color='gray'
                style={{
                  width: '98%',
                  height: '1px',
                  margin: '0 auto',
                }}
              />
            )}
          </Fragment>
        ))
      )}
    </Flex>
  )
}

export default NotificationsList
